import { TableProps } from '../Table/table.types';
import Handler from '../../commonTypes/handler.types';

export enum SortOrderTypes {
  ASC = 'asc',
  DESC = 'desc',
  TOGGLE = 'toggle',
}

export interface DataTableProps extends TableProps {
  sortState?: SortOrderTypes;
  handlers?: Handler;
  highlightSortedColumn?: boolean;
}
